module.exports = __webpack_public_path__ + "img/m-hd.dbaa3d00.jpg";